<template>
  <el-container
    class="name-card-decoration"
  >
    <el-aside
      class="aside"
    >
      <decoration-preview
        ref="preview"
        :name="currentName"
      ></decoration-preview>
    </el-aside>
    <el-main>
      <decoration-config
        @on-change="hanleOnChange"
        @on-active-click="handleOnActiveClick"
        @on-tab-click="handleOnTabClick"
        @on-title-change="handleOnTitleChange"
      ></decoration-config>
    </el-main>
  </el-container>
</template>

<script>
import DecorationPreview from './components/decoration-preview/index.vue'
import DecorationConfig from './components/decoration-config/index.vue'
export default {
  name: 'NameCardDecoration',
  components: {
    DecorationPreview,
    DecorationConfig
  },
  data () {
    return {
      showIframe: false,
      currentName: '名片'
    }
  },
  methods: {
    hanleOnChange (data) {
      this.$refs.preview.messager.emit('onChange', data)
    },
    handleOnActiveClick (name) {
      this.$refs.preview.messager.emit('onActiveChange', name)
    },
    handleOnTitleChange (data) {
      this.$refs.preview.messager.emit('onTitleChange', data)
    },
    handleOnTabClick (name) {
      if (name === 'nameCardSetting') {
        this.currentName = '名片'
      } else {
        this.currentName = '商品'
      }
      this.$refs.preview.messager.emit('onTabChange', name)
    }
  }
}
</script>

<style lang="scss" scoped>
.name-card-decoration {
  height: 100%;
  background-color: #f0f1f2;

  .aside {
    width: 500px !important;
    height: 100%;
  }

  /deep/.el-main {
    padding: 0;
    background-color: #fff;
  }
}
</style>
